import { Can } from 'providers/casl'

export const onGlobalSetupDefaultsPrebidStackAccess = (can: Can) => {
  can('access', 'GlobalSetupPage-defaults-prebidStack')
}

export const onGlobalSetupDefaultsPrebidStackUpdate = (can: Can) => {
  can('update', 'GlobalSetupFeature-defaults-prebidStack')
}

export const onGlobalSetupDefaultsRichPlacementsAccess = (can: Can) => {
  can('access', 'GlobalSetupPage-defaults-richPlacements')
}

export const onGlobalSetupDefaultsRichPlacementsUpdate = (can: Can) => {
  can('update', 'GlobalSetupFeature-defaults-richPlacements')
}

export const onGlobalSetupDefaultsRichPlacementsFrequencyCappingRead = (can: Can) => {
  can('read', 'GlobalSetupField-frequencyCapping')
}

export const onGlobalSetupDefaultsRichPlacementsFrequencyCappingUpdate = (can: Can) => {
  can('update', 'GlobalSetupField-frequencyCapping')
}

export const onGlobalSetupDefaultsPrebidVariableNameRead = (can: Can) => {
  can('read', 'GlobalSetupField-prebidVariableName')
}

export const onGlobalSetupDefaultsPrebidVariableNameUpdate = (can: Can) => {
  can('update', 'GlobalSetupField-prebidVariableName')
}
